/**
 * ROSÉE theme.js
 * Cart drawer (Shopify AJAX Cart API), product form variant handling,
 * quick-add buttons, and scroll-reveal animations.
 */
(function () {
  'use strict';

  var strings = window.roseeStrings || {};
  var settings = window.roseeSettings || {};

  /* ---------- Utilities ---------- */

  function formatMoney(cents) {
    var format = strings.moneyFormat || '${{amount}}';
    var amount = (cents / 100).toFixed(2);
    return format
      .replace(/\{\{\s*amount\s*\}\}/, amount)
      .replace(/\{\{\s*amount_no_decimals\s*\}\}/, Math.round(cents / 100).toString())
      .replace(/\{\{\s*amount_with_comma_separator\s*\}\}/, amount.replace('.', ','));
  }

  var toastTimer;
  function toast(msg) {
    var el = document.getElementById('Toast');
    if (!el) return;
    el.textContent = msg;
    el.classList.add('show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { el.classList.remove('show'); }, 2200);
  }

  /* ---------- Cart drawer ---------- */

  var drawer = document.querySelector('[data-cart-drawer]');
  var overlay = document.querySelector('[data-cart-overlay]');

  function openCart() {
    if (!drawer) return;
    drawer.classList.add('open');
    overlay.classList.add('open');
    refreshCart();
  }

  function closeCart() {
    if (!drawer) return;
    drawer.classList.remove('open');
    overlay.classList.remove('open');
  }

  function popBadge() {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.classList.add('pop');
      setTimeout(function () { el.classList.remove('pop'); }, 300);
    });
  }

  function renderCart(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) {
      el.textContent = cart.item_count;
    });

    var totalEl = document.querySelector('[data-cart-total]');
    if (totalEl) totalEl.textContent = formatMoney(cart.total_price);

    var shipEl = document.querySelector('[data-ship-msg]');
    if (shipEl) {
      var threshold = settings.freeShippingThreshold || 0;
      if (cart.total_price === 0 || threshold === 0) {
        shipEl.innerHTML = '';
      } else if (cart.total_price < threshold) {
        var away = (strings.freeShippingAway || "You're {{ amount }} away from free shipping")
          .replace('{{ amount }}', formatMoney(threshold - cart.total_price));
        shipEl.innerHTML = away +
          '<div class="ship-bar"><i style="width:' + Math.min(100, (cart.total_price / threshold) * 100) + '%"></i></div>';
      } else {
        shipEl.innerHTML = (strings.freeShippingUnlocked || 'Free shipping unlocked') +
          '<div class="ship-bar"><i style="width:100%"></i></div>';
      }
    }

    var box = document.querySelector('[data-cart-items]');
    if (!box) return;

    if (cart.items.length === 0) {
      box.innerHTML = '<div class="cart-empty"><div class="eyebrow">Your bag is empty</div>' +
        '<p>Fill it with something beautiful.</p></div>';
      return;
    }

    box.innerHTML = cart.items.map(function (item, i) {
      var img = item.image
        ? '<img src="' + item.image.replace(/(\.[a-z]+)(\?|$)/, '_152x$1$2') + '" alt="" loading="lazy">'
        : '<div class="bottle bottle--sm"></div>';
      var variant = item.variant_title ? '<div class="ci-shade">' + item.variant_title + '</div>' : '';
      return '<div class="cart-item">' +
        '<div class="ci-thumb">' + img + '</div>' +
        '<div class="ci-body">' +
        '<h4>' + item.product_title + '</h4>' + variant +
        '<div class="ci-row">' +
        '<div class="ci-qty">' +
        '<button data-line-qty data-line="' + (i + 1) + '" data-qty="' + (item.quantity - 1) + '" aria-label="Decrease">−</button>' +
        '<output>' + item.quantity + '</output>' +
        '<button data-line-qty data-line="' + (i + 1) + '" data-qty="' + (item.quantity + 1) + '" aria-label="Increase">+</button>' +
        '</div>' +
        '<div class="ci-price">' + formatMoney(item.final_line_price) + '</div>' +
        '</div>' +
        '<button class="ci-remove" data-line-qty data-line="' + (i + 1) + '" data-qty="0">Remove</button>' +
        '</div></div>';
    }).join('');
  }

  function refreshCart() {
    return fetch('/cart.js')
      .then(function (r) { return r.json(); })
      .then(renderCart)
      .catch(function () { toast(strings.cartError || 'Error'); });
  }

  function addToCart(variantId, quantity) {
    return fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity || 1 })
    }).then(function (r) {
      if (!r.ok) throw new Error('add failed');
      return r.json();
    }).then(function () {
      toast(strings.addedToBag || 'Added to bag ✦');
      popBadge();
      openCart();
    }).catch(function () {
      toast(strings.cartError || 'Something went wrong.');
    });
  }

  function changeLine(line, qty) {
    return fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ line: line, quantity: qty })
    }).then(function (r) { return r.json(); })
      .then(function (cart) { renderCart(cart); popBadge(); })
      .catch(function () { toast(strings.cartError || 'Error'); });
  }

  /* ---------- Event delegation ---------- */

  document.addEventListener('click', function (e) {
    var toggle = e.target.closest('[data-cart-toggle]');
    if (toggle) { e.preventDefault(); openCart(); return; }

    if (e.target.closest('[data-cart-close]') || e.target === overlay) { closeCart(); return; }

    var checkoutBtn = e.target.closest('[data-checkout]');
    if (checkoutBtn) { window.location.href = '/checkout'; return; }

    var quickAdd = e.target.closest('[data-quick-add]');
    if (quickAdd) {
      e.preventDefault();
      e.stopPropagation();
      addToCart(parseInt(quickAdd.dataset.variantId, 10), 1);
      return;
    }

    var lineBtn = e.target.closest('[data-line-qty]');
    if (lineBtn) {
      changeLine(parseInt(lineBtn.dataset.line, 10), parseInt(lineBtn.dataset.qty, 10));
      return;
    }
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape') closeCart();
  });

  /* ---------- Product form ---------- */

  var form = document.querySelector('[data-product-form], #ProductForm');
  if (form) {
    var variantsScript = form.querySelector('[data-variants-json]');
    var variants = variantsScript ? JSON.parse(variantsScript.textContent) : [];
    var variantInput = form.querySelector('[data-variant-id]');
    var addButton = form.querySelector('[data-add-button]');
    var qtyInput = form.querySelector('[data-qty-input]');

    form.addEventListener('click', function (e) {
      if (e.target.closest('[data-qty-minus]')) {
        qtyInput.value = Math.max(1, parseInt(qtyInput.value, 10) - 1);
      }
      if (e.target.closest('[data-qty-plus]')) {
        qtyInput.value = parseInt(qtyInput.value, 10) + 1;
      }
    });

    form.addEventListener('change', function (e) {
      if (!e.target.matches('input[type="radio"]')) return;

      form.querySelectorAll('.pdp-options').forEach(function (group) {
        group.querySelectorAll('.pdp-option').forEach(function (label) {
          label.classList.toggle('sel', label.querySelector('input').checked);
        });
      });

      var selected = [];
      form.querySelectorAll('.pdp-options').forEach(function (group) {
        var checked = group.querySelector('input:checked');
        selected.push(checked ? checked.value : null);
      });

      var match = variants.find(function (v) {
        return selected.every(function (val, i) { return v.options[i] === val; });
      });

      if (match) {
        variantInput.value = match.id;
        if (addButton) {
          addButton.disabled = !match.available;
          addButton.textContent = match.available
            ? (strings.addedToBag ? 'Add to Bag' : 'Add to Bag')
            : 'Sold Out';
        }
        var priceEl = document.querySelector('[data-price]');
        if (priceEl) {
          priceEl.innerHTML = (match.compare_at_price > match.price
            ? '<s>' + formatMoney(match.compare_at_price) + '</s>' : '') + formatMoney(match.price);
        }
      }
    });

    form.addEventListener('submit', function (e) {
      e.preventDefault();
      addToCart(parseInt(variantInput.value, 10), parseInt(qtyInput.value, 10) || 1);
    });
  }

  /* ---------- Product gallery thumbs ---------- */

  document.querySelectorAll('[data-thumb]').forEach(function (thumb) {
    thumb.addEventListener('click', function () {
      document.querySelectorAll('[data-thumb]').forEach(function (t) { t.classList.remove('sel'); });
      thumb.classList.add('sel');
      var main = document.getElementById('PdpMainImage');
      if (main) main.src = thumb.dataset.src;
    });
  });

  /* ---------- Scroll reveal ---------- */

  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('visible');
          io.unobserve(entry.target);
        }
      });
    }, { threshold: 0.12 });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else {
    document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('visible'); });
  }

  /* ---------- Initial cart state ---------- */
  refreshCart();
})();
